/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    DatabaseAudioPageBlock,
    instanceOfDatabaseAudioPageBlock,
    DatabaseAudioPageBlockFromJSON,
    DatabaseAudioPageBlockFromJSONTyped,
    DatabaseAudioPageBlockToJSON,
} from './DatabaseAudioPageBlock';
import {
    DatabaseBannerPageBlock,
    instanceOfDatabaseBannerPageBlock,
    DatabaseBannerPageBlockFromJSON,
    DatabaseBannerPageBlockFromJSONTyped,
    DatabaseBannerPageBlockToJSON,
} from './DatabaseBannerPageBlock';
import {
    DatabaseEingabelistePageBlock,
    instanceOfDatabaseEingabelistePageBlock,
    DatabaseEingabelistePageBlockFromJSON,
    DatabaseEingabelistePageBlockFromJSONTyped,
    DatabaseEingabelistePageBlockToJSON,
} from './DatabaseEingabelistePageBlock';
import {
    DatabaseFieldPageBlock,
    instanceOfDatabaseFieldPageBlock,
    DatabaseFieldPageBlockFromJSON,
    DatabaseFieldPageBlockFromJSONTyped,
    DatabaseFieldPageBlockToJSON,
} from './DatabaseFieldPageBlock';
import {
    DatabaseImageListPageBlock,
    instanceOfDatabaseImageListPageBlock,
    DatabaseImageListPageBlockFromJSON,
    DatabaseImageListPageBlockFromJSONTyped,
    DatabaseImageListPageBlockToJSON,
} from './DatabaseImageListPageBlock';
import {
    DatabaseImagePageBlock,
    instanceOfDatabaseImagePageBlock,
    DatabaseImagePageBlockFromJSON,
    DatabaseImagePageBlockFromJSONTyped,
    DatabaseImagePageBlockToJSON,
} from './DatabaseImagePageBlock';
import {
    DatabaseMapPageBlock,
    instanceOfDatabaseMapPageBlock,
    DatabaseMapPageBlockFromJSON,
    DatabaseMapPageBlockFromJSONTyped,
    DatabaseMapPageBlockToJSON,
} from './DatabaseMapPageBlock';
import {
    DatabaseNamePageBlock,
    instanceOfDatabaseNamePageBlock,
    DatabaseNamePageBlockFromJSON,
    DatabaseNamePageBlockFromJSONTyped,
    DatabaseNamePageBlockToJSON,
} from './DatabaseNamePageBlock';
import {
    DatabaseNewsletterPageBlock,
    instanceOfDatabaseNewsletterPageBlock,
    DatabaseNewsletterPageBlockFromJSON,
    DatabaseNewsletterPageBlockFromJSONTyped,
    DatabaseNewsletterPageBlockToJSON,
} from './DatabaseNewsletterPageBlock';
import {
    DatabasePageBlock,
    instanceOfDatabasePageBlock,
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import {
    DatabaseSubDbListPageBlock,
    instanceOfDatabaseSubDbListPageBlock,
    DatabaseSubDbListPageBlockFromJSON,
    DatabaseSubDbListPageBlockFromJSONTyped,
    DatabaseSubDbListPageBlockToJSON,
} from './DatabaseSubDbListPageBlock';
import {
    DatabaseSubDbTablePageBlock,
    instanceOfDatabaseSubDbTablePageBlock,
    DatabaseSubDbTablePageBlockFromJSON,
    DatabaseSubDbTablePageBlockFromJSONTyped,
    DatabaseSubDbTablePageBlockToJSON,
} from './DatabaseSubDbTablePageBlock';
import {
    DatabaseTeaserImagePageBlock,
    instanceOfDatabaseTeaserImagePageBlock,
    DatabaseTeaserImagePageBlockFromJSON,
    DatabaseTeaserImagePageBlockFromJSONTyped,
    DatabaseTeaserImagePageBlockToJSON,
} from './DatabaseTeaserImagePageBlock';
import {
    DatabaseTextPageBlock,
    instanceOfDatabaseTextPageBlock,
    DatabaseTextPageBlockFromJSON,
    DatabaseTextPageBlockFromJSONTyped,
    DatabaseTextPageBlockToJSON,
} from './DatabaseTextPageBlock';
import {
    DatabaseTitlePageBlock,
    instanceOfDatabaseTitlePageBlock,
    DatabaseTitlePageBlockFromJSON,
    DatabaseTitlePageBlockFromJSONTyped,
    DatabaseTitlePageBlockToJSON,
} from './DatabaseTitlePageBlock';
import {
    DatabaseVideoPageBlock,
    instanceOfDatabaseVideoPageBlock,
    DatabaseVideoPageBlockFromJSON,
    DatabaseVideoPageBlockFromJSONTyped,
    DatabaseVideoPageBlockToJSON,
} from './DatabaseVideoPageBlock';

/**
 * @type DatabaseContentPageContentBlocksInner
 * 
 * @export
 */
export type DatabaseContentPageContentBlocksInner = { blockType: 'AUDIO' } & DatabaseAudioPageBlock | { blockType: 'BANNER' } & DatabaseBannerPageBlock | { blockType: 'BASE' } & DatabasePageBlock | { blockType: 'DB_NAME' } & DatabaseNamePageBlock | { blockType: 'DB_TEASER_IMAGE' } & DatabaseTeaserImagePageBlock | { blockType: 'DB_TITLE' } & DatabaseTitlePageBlock | { blockType: 'EINGABELISTE' } & DatabaseEingabelistePageBlock | { blockType: 'FIELD' } & DatabaseFieldPageBlock | { blockType: 'IMAGE' } & DatabaseImagePageBlock | { blockType: 'IMAGE_LIST' } & DatabaseImageListPageBlock | { blockType: 'MAP' } & DatabaseMapPageBlock | { blockType: 'NEWSLETTER' } & DatabaseNewsletterPageBlock | { blockType: 'SUB_DB_LIST' } & DatabaseSubDbListPageBlock | { blockType: 'SUB_DB_TABLE' } & DatabaseSubDbTablePageBlock | { blockType: 'TEXT' } & DatabaseTextPageBlock | { blockType: 'VIDEO' } & DatabaseVideoPageBlock;

export function DatabaseContentPageContentBlocksInnerFromJSON(json: any): DatabaseContentPageContentBlocksInner {
    return DatabaseContentPageContentBlocksInnerFromJSONTyped(json, false);
}

export function DatabaseContentPageContentBlocksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseContentPageContentBlocksInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['blockType']) {
        case 'AUDIO':
            return {...DatabaseAudioPageBlockFromJSONTyped(json, true), blockType: 'AUDIO'};
        case 'BANNER':
            return {...DatabaseBannerPageBlockFromJSONTyped(json, true), blockType: 'BANNER'};
        case 'BASE':
            return {...DatabasePageBlockFromJSONTyped(json, true), blockType: 'BASE'};
        case 'DB_NAME':
            return {...DatabaseNamePageBlockFromJSONTyped(json, true), blockType: 'DB_NAME'};
        case 'DB_TEASER_IMAGE':
            return {...DatabaseTeaserImagePageBlockFromJSONTyped(json, true), blockType: 'DB_TEASER_IMAGE'};
        case 'DB_TITLE':
            return {...DatabaseTitlePageBlockFromJSONTyped(json, true), blockType: 'DB_TITLE'};
        case 'EINGABELISTE':
            return {...DatabaseEingabelistePageBlockFromJSONTyped(json, true), blockType: 'EINGABELISTE'};
        case 'FIELD':
            return {...DatabaseFieldPageBlockFromJSONTyped(json, true), blockType: 'FIELD'};
        case 'IMAGE':
            return {...DatabaseImagePageBlockFromJSONTyped(json, true), blockType: 'IMAGE'};
        case 'IMAGE_LIST':
            return {...DatabaseImageListPageBlockFromJSONTyped(json, true), blockType: 'IMAGE_LIST'};
        case 'MAP':
            return {...DatabaseMapPageBlockFromJSONTyped(json, true), blockType: 'MAP'};
        case 'NEWSLETTER':
            return {...DatabaseNewsletterPageBlockFromJSONTyped(json, true), blockType: 'NEWSLETTER'};
        case 'SUB_DB_LIST':
            return {...DatabaseSubDbListPageBlockFromJSONTyped(json, true), blockType: 'SUB_DB_LIST'};
        case 'SUB_DB_TABLE':
            return {...DatabaseSubDbTablePageBlockFromJSONTyped(json, true), blockType: 'SUB_DB_TABLE'};
        case 'TEXT':
            return {...DatabaseTextPageBlockFromJSONTyped(json, true), blockType: 'TEXT'};
        case 'VIDEO':
            return {...DatabaseVideoPageBlockFromJSONTyped(json, true), blockType: 'VIDEO'};
        default:
            throw new Error(`No variant of DatabaseContentPageContentBlocksInner exists with 'blockType=${json['blockType']}'`);
    }
}

export function DatabaseContentPageContentBlocksInnerToJSON(value?: DatabaseContentPageContentBlocksInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['blockType']) {
        case 'AUDIO':
            return DatabaseAudioPageBlockToJSON(value);
        case 'BANNER':
            return DatabaseBannerPageBlockToJSON(value);
        case 'BASE':
            return DatabasePageBlockToJSON(value);
        case 'DB_NAME':
            return DatabaseNamePageBlockToJSON(value);
        case 'DB_TEASER_IMAGE':
            return DatabaseTeaserImagePageBlockToJSON(value);
        case 'DB_TITLE':
            return DatabaseTitlePageBlockToJSON(value);
        case 'EINGABELISTE':
            return DatabaseEingabelistePageBlockToJSON(value);
        case 'FIELD':
            return DatabaseFieldPageBlockToJSON(value);
        case 'IMAGE':
            return DatabaseImagePageBlockToJSON(value);
        case 'IMAGE_LIST':
            return DatabaseImageListPageBlockToJSON(value);
        case 'MAP':
            return DatabaseMapPageBlockToJSON(value);
        case 'NEWSLETTER':
            return DatabaseNewsletterPageBlockToJSON(value);
        case 'SUB_DB_LIST':
            return DatabaseSubDbListPageBlockToJSON(value);
        case 'SUB_DB_TABLE':
            return DatabaseSubDbTablePageBlockToJSON(value);
        case 'TEXT':
            return DatabaseTextPageBlockToJSON(value);
        case 'VIDEO':
            return DatabaseVideoPageBlockToJSON(value);
        default:
            throw new Error(`No variant of DatabaseContentPageContentBlocksInner exists with 'blockType=${value['blockType']}'`);
    }

}

